// @flow
import * as React from 'react';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import styles from './FollowSellerButton.module.scss';

type Props = {
    children: React.Node,
    followed: boolean,
    longText?: boolean,
    primaryWithSecondarySuccess: boolean,
    secondary: boolean,
    small: boolean,
};
//TODO op-118 is this ok? There was no primary secondarySuccess option, so I am not sure what this was supposed to do.
const FollowSellerButton = (props: Props) => {
    const {
        children,
        followed = false,
        longText,
        primaryWithSecondarySuccess = false,
        secondary = false,
        small = false,
    } = props;

    if (children) {
        return (
            <Button primary={!followed} secondary={followed} small={small} e2e="followSellerButton">
                {children}
            </Button>
        );
    }

    const follow = !longText ? 'follow' : 'follow_auctioneer';
    const following = !longText ? 'following' : 'following_auctioneer';

    if (secondary) {
        return (
            <Button secondary={followed} green={followed} small={small} e2e="followSellerButton">
                {!followed ? (
                    <React.Fragment>
                        <FontAwesomeIcon icon={faEnvelope} className={styles.icon} />
                        <FormattedMessage id={follow} />
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <FontAwesomeIcon icon={faCheckCircle} className={styles.icon} />
                        <FormattedMessage id={following} />
                    </React.Fragment>
                )}
            </Button>
        );
    }

    if (primaryWithSecondarySuccess) {
        return (
            <Button primary={!followed} secondary={followed} green={followed} small={small} e2e="followSellerButton">
                {!followed ? (
                    <React.Fragment>
                        <FontAwesomeIcon icon={faEnvelope} className={styles.icon} />
                        <FormattedMessage id={follow} />
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <FontAwesomeIcon icon={faCheckCircle} className={styles.icon} />
                        <FormattedMessage id={following} />
                    </React.Fragment>
                )}
            </Button>
        );
    }

    return (
        <Button primary={!followed} secondary={followed} small={small} e2e="followSellerButton">
            <FontAwesomeIcon icon={faEnvelope} className={styles.icon} />
            {!followed ? <FormattedMessage id={follow} /> : <FormattedMessage id={following} />}
        </Button>
    );
};

export default React.memo<Props>(FollowSellerButton, isEqual);
